import { Box, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Slider } from '~/components/Slider';
import { WindowLevel } from '~/domain/patient/windowLevel';
import WindowingPresets from './WindowingPresets';
import ResetWindowingLevelButton from './ResetWindowingLevelButton';
import useWindowLevel from '~/hooks/useWindowLevel';

export default function WindowingToolOptions() {
    const { windowLevel, setWindowLevel } = useWindowLevel();

    const setWindowWidth = (ww: number) => {
        if (windowLevel && windowLevel.level !== undefined) {
            setWindowLevel(new WindowLevel(ww, windowLevel.level));
        }
    };

    const setWindowCenter = (wc: number) => {
        if (windowLevel && windowLevel.window !== undefined) {
            setWindowLevel(new WindowLevel(windowLevel.window, wc));
        }
    };

    return (
        windowLevel && (
            <Box sx={{ m: 2 }}>
                <Box display={'flex'} alignItems={'center'}>
                    <Typography variant="h6">
                        <FormattedMessage id="windowing" />
                    </Typography>
                    <Divider
                        flexItem
                        orientation="vertical"
                        sx={{ mx: 1, my: 1 }}
                    />
                    <ResetWindowingLevelButton />
                </Box>
                <Box display="grid" rowGap={2} my={2}>
                    <WindowingPresets />
                    <Slider
                        label={<FormattedMessage id="windowWidth" />}
                        onChange={setWindowWidth}
                        value={windowLevel.window}
                        min={0}
                        max={3000}
                        showDecimals={false}
                    />
                    <Slider
                        label={<FormattedMessage id="windowCenter" />}
                        onChange={setWindowCenter}
                        value={windowLevel.level}
                        min={-200}
                        max={1000}
                        showDecimals={false}
                    />
                </Box>
            </Box>
        )
    );
}
